<template>
  <div>
    <div class="attr-top">
      <i-row style="width:100%">
        <i-col :xs="24" :sm="24" :md="18" :lg="20" style="margin:8px 0" class="attr-search">
          <i-input
            placeholder="模糊搜索"
            style="width: 200px;margin: 0 auto;"
            v-model="searchKey"
            clearable
            @on-clear="searchKeyClear"
            @keyup.enter.native="searchBth"
          />
          <i-button type="info" icon="md-search" class="search" @click="searchBth">搜索</i-button>
        </i-col>
        <i-col :xs="24" :sm="24" :md="6" :lg="4" style="margin:8px 0">
          <i-button type="success" class="article-button" style="margin: 0 auto;" @click="addAttr">
            <i class="iconfont icon-tianjia" style="marginRight:5px;width: 60px;margin: 0 auto;"></i>
            新增
          </i-button>
        </i-col>
      </i-row>
    </div>
    <div class="attr-main">
      <i-table class="attr-table" :columns="columns" :data="attrData" ref="table" stripe border>
        <template slot="sortable" slot-scope="{ row }">
          <i-switch v-model="row.sortable" @on-change="changeSortable(row)" />
          {{ row.sortable ? "是" : "否" }}
        </template>
        <!-- 操作栏的按钮 -->
        <template slot="operate" slot-scope="{ row }">
          <i-button type="warning" class="article-button" @click="updateAttr(row)">
            <i class="iconfont icon-weibiaoti2010104" style="marginRight:5px;"></i>
            编辑
          </i-button>
          <i-button type="error" class="article-button" @click="deleteArrModel(row)">
            <i class="iconfont icon-shanchu" style="marginRight:5px"></i>
            删除
          </i-button>
        </template>
      </i-table>
      <!-- 分页插件 -->
      <i-page
        :total="total"
        :page-size-opts="[10, 20, 30, 40, 50, 100]"
        size="small"
        show-elevator
        show-sizer
        show-total
        placement="top"
        :current="current"
        :page-size="pageSize"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
    <!-- loading-->
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
    <!--更新模态框 -->
    <update-attr
      :show-modal="showUpdateModal"
      :update-data="updateData"
      @cancelModal="cancel"
      @updateList="getAttrList"
    ></update-attr>
    <!-- 增加模态框 -->
    <add-attr
      :showModal="showAddAttrModal"
      :attr-name="attrName"
      :attr-desc="attrDesc"
      :attr-id="attrId"
      @cancelModal="cancel"
      @updateList="getAttrList"
    ></add-attr>
    <!-- 单项删除 -->
    <i-modal v-model="modal1" title="确认框" @on-ok="deleteAttr(deleteModalData)">
      <p>确认删除属性{{ deleteModalData.name }}吗？</p>
    </i-modal>
  </div>
</template>

<script>
import AddAttr from "./Attribute/AddAttr.vue"
import UpdateAttr from "./Attribute/UpdateAttr.vue"
import { baseConfigMixin } from "./mixin"
export default {
  name: "Attr",
  components: {
    AddAttr,
    UpdateAttr,
  },
  mixins: [baseConfigMixin],
  data() {
    // let global = this
    return {
      showAddAttrModal: false, //是否显示添加用户弹窗
      showUpdateModal: false, //是否显示更新用户弹窗
      modal1: false, //删除框
      attrName: "", //属性的名字
      attrDesc: "", //属性的简介
      attrId: "", //属性的id
      updateData: {},
      total: 10,
      current: 1,
      pageSize: null,
      columns: [
        {
          type: "selection",
          width: 30,
          align: "center",
          resizable: true,
        },
        {
          title: "名称",
          key: "name",
          width: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "简介",
          key: "desc",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "类型",
          key: "type",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "是否支持排序",
          key: "sortable",
          slot: "sortable",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          width: 300,
          align: "center",
        },
      ],
      searchKey: "",
      showLoading: true,
      deleteModalData: {},
      attrData: [],
    }
  },
  methods: {
    // 弹出新增
    addAttr() {
      this.showAddAttrModal = true
    },
    // 将数据置为空
    cancel() {
      this.attrName = ""
      this.attrDesc = ""
      this.attrId = ""
      this.updateData = {}
      this.showAddAttrModal = false
      this.showUpdateModal = false
    },
    //编辑弹窗
    updateAttr(row) {
      this.showUpdateModal = true
      this.updateData = row
    },
    //删除属性的弹窗
    deleteArrModel(row) {
      this.modal1 = true
      this.deleteModalData = row
    },
    // 删除属性
    async deleteAttr(row) {
      const res = await this.axios({
        method: "delete",
        url: this.cmsUrl + "api/content/attribute/delete",
        params: {
          aids: row.id,
        },
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        await this.getAttrList()
      } else {
        this.$Message.error(res.data.error_message)
      }
    },
    // page改变事件
    pageChange(index) {
      this.current = index
      this.getAttrList()
    },
    pageSizeChange(size) {
      this.pageSize = size
      localStorage.setItem("pageSize", size)
      this.$store.commit("changePageSize", size)
      this.getAttrList()
    },
    // 搜索
    searchBth() {
      this.current = 1
      this.getAttrList()
    },
    searchKeyClear() {
      this.current = 1
      this.getAttrList()
    },
    //获取属性列表
    async getAttrList() {
      let self = this
      self.showLoading = true
      let xData = {}
      xData = {
        //页码
        p: this.current,
        //每页记录数
        p_size: this.pageSize,
      }
      if (this.searchKey) {
        xData["search_key"] = this.searchKey
      }
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/attribute/list",
          params: {
            ...xData,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.attrData = res.data.data.data
          this.total = res.data.data.total
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
      }
    },
    async changeSortable(row) {
      const res = await this.axios({
        method: "post",
        url: this.cmsUrl + "api/content/attribute/edit",
        data: {
          aid: row.id,
          sortable: row.sortable,
        },
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        this.$Message.success("属性名称修改成功")
      } else {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
      }
    },
  },
  mounted() {
    if (localStorage.pageSize === undefined) {
      this.pageSize = 10
    } else {
      this.pageSize = Number(localStorage.pageSize)
    }
    if (this.$route.query.searchKey !== undefined) {
      this.searchKey = this.$route.query.searchKey
    }
    this.getAttrList()
  },
}
</script>

<style scoped>
.attr-top {
  margin-top: 10px;
  margin-bottom: 10px;
}

.title {
  text-align: center;
}

/* .attr-button {
  margin-left: -200px;
} */
.attr-search {
  min-width: 302px;
}

.attr-search .search {
  margin-left: 20px;
}

.attr-main {
  padding: 0 20px;
}

.article-button {
  margin-right: 5px;
}

>>> .ivu-table-cell {
  padding: 5px !important;
}

>>> .ivu-tooltip-inner {
  border: 1px solid white;
}

.attr-table {
  overflow: visible !important;
}
</style>

<style lang="scss">
/* 让modal居中 */
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
